import storage from '@/utils/storage';
export const Logout = () => {
  storage.clear();
  return <></>;
};
